export function getTimestamp() {
    return Math.floor(Date.now() / 1000);
}

export function getRandomColor() {
    return { r: Math.round(Math.random() * 255), g: Math.round(Math.random() * 255), b: Math.round(Math.random() * 255), a: 1 };
}

export function getColorsGradients(minColor, maxColor, steps) {
    let redInterval = maxColor.r - minColor.r;
    let greenInterval = maxColor.g - minColor.g;
    let blueInterval = maxColor.b - minColor.b;
    let alphaInterval = maxColor.a - minColor.a;
    redInterval = redInterval < 0 ? 0 : redInterval;
    greenInterval = greenInterval < 0 ? 0 : greenInterval;
    blueInterval = blueInterval < 0 ? 0 : blueInterval;
    alphaInterval = alphaInterval < 0 ? 0 : alphaInterval;
    let stepsValues = [];
    stepsValues.push(minColor);
    if (steps > 2) {
        for (let i = 2; i < steps; ++i) {
            let stepColor = {};
            stepColor.r = redInterval != 0 ? Math.floor((minColor.r + redInterval) / steps * i) : minColor.r;
            stepColor.g = greenInterval != 0 ? Math.floor((minColor.g + greenInterval) / steps * i) : minColor.g;
            stepColor.b = blueInterval != 0 ? Math.floor((minColor.b + blueInterval) / steps * i) : minColor.b;
            stepColor.a = alphaInterval != 0 ? (minColor.a + alphaInterval) / steps * i : minColor.a;
            stepsValues.push(stepColor);
        }
    }
    stepsValues.push(maxColor);
    return stepsValues;
}

export function hexToRgb(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: 1
    } : null;
}

export function getBase64Image(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export function childrenOfType(element, type, attribute, attributeValue, elementClass) {
    let matches = [];
    let typeFunction = x => type === undefined || (x.tagName !== undefined && x.tagName === type);
    let attributeFunction = x => attribute === undefined || x.getAttribute(attribute) === attributeValue;
    let classFunction = x => elementClass === undefined || x.classList.contains(elementClass);
    if (typeFunction(element) && attributeFunction(element) && classFunction(element)) {
        matches.push(element);
    }
    let children = element.children;
    let child;
    if (children !== undefined) {
        for (let i = 0; i < children.length; ++i) {
            child = children[i].elm !== undefined ? children[i].elm : children[i];
            if (typeFunction(child) && attributeFunction(child) && classFunction(child)) {
                matches.push(child);
            }
            if (child.firstChild) {
                matches.push.apply(matches, childrenOfType(child, type, attribute, attributeValue, elementClass));
            }
        }
    }
    return matches;
}

export function hasSomeParentWithClass(element, className) {
    if (element.className && element.className.split(' ').indexOf(className) >= 0) {
        return true;
    }
    return element.parentNode && hasSomeParentWithClass(element.parentNode, className);
}

export function getParentWithClass(element, className) {
    if (element.className.split(' ').indexOf(className) >= 0) {
        return element;
    }
    if (element.parentNode) {
        return getParentWithClass(element.parentNode, className);
    }
    return null;
}

export function isUrl(url) {
    const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return regexp.test(url);
}

export function roundNumber(num, scale) {
    return +(Math.round(num + "e+" + scale.toString()) + "e-" + scale.toString());
}

export function checkErrorMessage(error, code, message) {
    return error != null && error.hasOwnProperty('response') &&
        ((code === undefined || code === null) || (error.response.hasOwnProperty('statusCode') && error.response.statusCode === code)) &&
        ((message === undefined || message === null) || (error.hasOwnProperty('body') && error.body.hasOwnProperty('error') && error.body.error === message));
}

export function baseUrl(url) {
    const a = document.createElement('a');
    a.href = url;
    return a.protocol + '//' + a.hostname;
}

export function linkShortenerFormatter(value) {
    if (value) {
        const baseUrlFromValue = baseUrl(value);
        return `<a href="${value}" title="Przejdź do ${value}">${baseUrlFromValue}</a>`;
    }
    return value;
}

export function textShortenerFormatter(value, maxLength, smartShortening) {
    if (value && maxLength) {
        const lengthExceeded = value.length > maxLength;
        let shortenedString = value;
        let result = shortenedString;
        if (lengthExceeded) {
            if (smartShortening) {
                const buffer = Math.round(maxLength * 0.25);
                const buffString = value.substring(maxLength - buffer, maxLength + buffer);
                const endChars = [' ', '.', ',', ';', ':', '/', '\n'];
                let endCharsIndexesBuffer = [];
                for (let i = 0; i < buffString.length; ++i) {
                    for(let j = 0; j < endChars.length; ++j) {
                        if(buffString[i] === endChars[j]){
                            endCharsIndexesBuffer.push(i);
                        }
                    }
                }
                let endCharIndex = -1;
                if(endCharsIndexesBuffer.length) {
                    endCharIndex = endCharsIndexesBuffer.reduce((prev, curr) => Math.abs(curr - buffer) < Math.abs(prev - buffer) ? curr : prev) + (maxLength - buffer);
                } else {
                    endCharIndex = maxLength;
                }
                shortenedString = value.substring(0, endCharIndex);
            } else {
                shortenedString = value.substring(0, maxLength);
            }
            shortenedString += '...';
            result = `<span title="${value}">${shortenedString}</span>`;
        }
        return result;
    }
    return value;
}

export function changeFeaturePropertiesNames(featureProperties){

  let dictionaryNames = [

    {key: 'id_stawki', value: 'id_stawki'},
    {key: 'id', value: 'id'},
    {key: 'wojewodztwo', value: 'wojewodztwo'},
    {key: 'powiat', value: 'powiat'},
    {key: 'gmina', value: 'gmina'},
    {key: 'kod_terc', value: 'kod_terc_Z.3.I.2'},
    {key: 'kategoria_drogi_1', value: 'kategoria_drogi_Z.3.2.1'},
    
    {key: 'stawka_zajecie_drogi_2', value: 'stawka_zajecie_drogi_Z.3.II.2'},
    {key: 'stawka_droga_zabudowana_21', value: 'stawka_droga_zabudowana_Z.3.II.2.1'},
    {key: 'w_jezdni_211', value: 'w_jezdni_Z.3.II.2.1.1'},
    {key: 'do_20_proc_szer_jezdni_2111', value: 'do_20_proc_szer_jezdni_Z.3.II.2.1.1.1'},
    {key: 'od_20_do_50_proc_szer_jezdni_2112', value: 'od_20_do_50_proc_szer_jezdni_Z.3.II.2.1.1.2'},
    {key: 'od_50_do_100_proc_szer_jezdni_2113', value: 'od_50_do_100_proc_szer_jezdni_Z.3.II.2.1.1.3'},
    {key: 'inne1_2114', value: 'inne_Z.3.II.2.1.1.4'},
    {key: 'poza_jezdnia_212', value: 'poza_jezdnia_Z.3.II.2.1.2'},
    {key: 'w_chodniku_2121', value: 'w_chodniku_Z.3.II.2.1.2.1'},
    {key: 'w_zatoce_postojowej_2122', value: 'w_zatoce_postojowej_Z.3.II.2.1.2.2'},
    {key: 'w_drodze_rowerowej_2123', value: 'w_drodze_rowerowej_Z.3.II.2.1.2.3'},
    {key: 'na_zajazdach_2124', value: 'na_zajazdach_Z.3.II.2.1.2.4'},
    {key: 'w_poboczu_2125', value: 'w_poboczu_Z.3.II.2.1.2.5'},
    {key: 'w_torowisku_tramwajowym_2126', value: 'w_torowisku_tramwajowym_Z.3.II.2.1.2.6'},
    {key: 'inne_2127', value: 'inne_Z.3.II.2.1.2.7'},
    {key: 'stawka_droga_niezabudowana_22', value: 'stawka_droga_niezabudowana_Z.3.II.2.2'},
    {key: 'w_jezdni_221', value: 'w_jezdni_Z.3.II.2.2.1'},
    {key: 'do_20_proc_szer_jezdni_2211', value: 'do_20_proc_szer_jezdni_Z.3.II.2.2.1.1'},
    {key: 'od_20_do_50_proc_szer_jezdni_2212', value: 'od_20_do_50_proc_szer_jezdni_Z.3.II.2.2.1.2'},
    {key: 'od_50_do_100_proc_szer_jezdni_2213', value: 'od_50_do_100_proc_szer_jezdni_Z.3.II.2.2.1.3'},
    {key: 'inne_2214', value: 'inne_Z.3.II.2.2.1.4'},
    {key: 'poza_jezdnia_222', value: 'poza_jezdnia_Z.3.II.2.2.2'},
    {key: 'w_chodniku_2221', value: 'w_chodniku_Z.3.II.2.2.2.1'},
    {key: 'w_zatoce_postojowej_2222', value: 'w_zatoce_postojowej_Z.3.II.2.2.2.2'},
    {key: 'w_drodze_rowerowej_2223', value: 'w_drodze_rowerowej_Z.3.II.2.2.2.3'},
    {key: 'na_zajazdach_2224', value: 'na_zajazdach_Z.3.II.2.2.2.4'},
    {key: 'w_poboczu_2225', value: '_poboczu_Z.3.II.2.2.2.5'},
    {key: 'w_torowisku_tramwajowym_2226', value: 'w_torowisku_tramwajowym_Z.3.II.2.2.2.6'},
    {key: 'inne_2227', value: 'inne_Z.3.II.2.2.2.7'},
    {key: 'stawki_zroznicowane_23', value: 'stawki_zroznicowane_Z.3.II.2.3'},

    {key: 'stawka_3', value: 'stawka_Z.3.II.3'},
    {key: 'stawka_droga_zabudowana_31', value: 'stawka_droga_zabudowana_Z.3.II.3.1'},
    {key: 'w_poprzek_drogi_311', value: 'w_poprzek_drogi_Z.3.II.3.1.1'},
    {key: 'w_jezdni_3111', value: 'w_jezdni_Z.3.II.3.1.1.1'},
    {key: 'poza_jezdnia_3112', value: 'poza_jezdnia_Z.3.II.3.1.1.2'},
    {key: 'wzdluz_drogi_312', value: 'wzdluz_drogi_Z.3.II.3.1.2'},
    {key: 'w_jezdni_3121', value: 'w_jezdni_Z.3.II.3.1.2.1'},
    {key: 'poza_jezdnia_3122', value: 'poza_jezdnia_Z.3.II.3.1.2.2'},
    {key: 'w_chodniku_31221', value: 'w_chodniku_31221'},
    {key: 'w_zatoce_postojowej_31222', value: 'w_zatoce_postojowej_Z.3.II.3.1.2.2.2'},
    {key: 'w_drodze_rowerowej_31223', value: 'w_drodze_rowerowej_Z.3.II.3.1.2.2.3'},
    {key: 'na_zjazdach_31224', value: 'na_zjazdach_Z.3.II.3.1.2.2.4'},
    {key: 'w_poboczu_31225', value: 'w_poboczu_Z.3.II.3.1.2.2.5'},
    {key: 'w_torowisku_tramwajowym_31226', value: 'w_torowisku_tramwajowym_Z.3.II.3.1.2.2.6'},
    {key: 'inne_31227', value: 'inne_Z.3.II.3.1.2.2.7'},
    {key: 'stawka_droga_niezabudowana_32', value: 'stawka_droga_niezabudowana_Z.3.II.3.2'},
    {key: 'w_poprzek_drogi_321', value: 'w_poprzek_drogi_Z.3.II.3.2.1'},
    {key: 'w_jezdni_3211', value: 'w_jezdni_Z.3.II.3.2.1.1'},
    {key: 'poza_jezdnia_3212', value: 'poza_jezdnia_Z.3.II.3.2.1.2'},
    {key: 'wzdluz_drogi_322', value: 'wzdluz_drogi_Z.3.II.3.2.2'},
    {key: 'w_jezdni_3221', value: 'w_jezdni_Z.3.II.3.2.2.1'},
    {key: 'poza_jezdnia_3222', value: 'poza_jezdnia_Z.3.II.3.2.2.2'},
    {key: 'w_chodniku_32221', value: 'w_chodniku_Z.3.II.3.2.2.2.1'},
    {key: 'w_zatoce_postojowej_32222', value: 'w_zatoce_postojowej_Z.3.II.3.2.2.2.2'},
    {key: 'w_drodze_rowerowej_32223', value: 'w_drodze_rowerowej_Z.3.II.3.2.2.2.3'},
    {key: 'na_zjazdach_32224', value: 'na_zjazdach_Z.3.II.3.2.2.2.4'},
    {key: 'w_poboczu_32225', value: 'w_poboczu_Z.3.II.3.2.2.2.5'},
    {key: 'w_torowisku_tramwajowym_32226', value: 'w_torowisku_tramwajowym_Z.3.II.3.2.2.2.6'},
    {key: 'inne_32227', value: 'inne_Z.3.II.3.2.2.2.7'},
    {key: 'stawka_obiekt_inzynierski_33', value: 'stawka_obiekt_inzynierski_Z.3.II.3.3'},
    {key: 'stawki_zroznicowane_34', value: 'stawki_zroznicowane_Z.3.II.3.4'},

    {key: 'stawka_4', value: 'stawka_Z.3.II.4'},
    {key: 'stawka_41', value: 'stawka_Z.3.II.4.1'},
    {key: 'stawka_42', value: 'stawka_Z.3.II.4.2'},
    {key: 'inne_43', value: 'inne_Z.3.II.4.3'},

    {key: 'nazwa_jednostki', value: 'nazwa_jednostki_Z.3.I.1'},
    {key: 'link_uchwaly', value: 'link_uchwaly'},
    {key: 'lista_zalacznikow', value: 'lista_zalacznikow'},
  ];

  var props={};
  
  dictionaryNames.forEach(function(propertyName){
    props[propertyName.value]=featureProperties[propertyName.key]?featureProperties[propertyName.key]:'';
  });

  return props;
}

